import { appConfig } from "_configs/appConfig";
import sharedConfig from "_configs/sharedConfig";
import TagManager from "react-gtm-module";
import ReactGA from "react-ga";
import i18next from "i18next";

class AnalyticsUtils {
    readonly crispPromise: Promise<any> | undefined;
    readonly enabled = !sharedConfig.isDev;

    constructor() {
        if (!__BROWSER__) {
            return;
        }
        ReactGA.initialize(appConfig.google.analytics, { debug: !sharedConfig.isProd, testMode: !sharedConfig.isProd });
        TagManager.initialize(appConfig.googleGtm);
        this.loadClarity();
        this.loadReCaptcha();
    }

    setUserInfo(email: string) {
        this.crispPromise?.then((crisp) => {
            crisp.push(["set", "user:email", email]);
        });
    }

    public loadPipedrive(url: string) {
        const lang = i18next.language;
        if (url.split("/")[1] === "en" && lang === "en") {
            return this._loadPipedrive().then(() => {
                const scriptElement = document.createElement("script");
                scriptElement.src = "https://leadbooster-chat.pipedrive.com/assets/loader.js";
                scriptElement.async = true;
                document.getElementsByTagName("head")[0].appendChild(scriptElement);
            });
        }
    }

    private _loadPipedrive() {
        return new Promise((resolve) => {
            (window as any).pipedriveLeadboosterConfig = {
                base: "leadbooster-chat.pipedrive.com",
                companyId: 7915705,
                playbookUuid: "a3f102ea-2663-48da-93a0-a5912487f66b",
                version: 2,
            };
            (function () {
                const w = window as any;
                if (w.LeadBooster) {
                    console.warn("LeadBooster already exists");
                } else {
                    w.LeadBooster = {
                        q: [],
                        on: function (n, h) {
                            this.q.push({ t: "o", n: n, h: h });
                        },
                        trigger: function (n) {
                            this.q.push({ t: "t", n: n });
                        },
                    };
                }
            })();
            resolve();
        });
    }

    private loadReCaptcha() {
        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?render=" + sharedConfig.reCaptcha.siteKey;
        // script.addEventListener("load", handleLoaded);
        document.body.appendChild(script);
    }

    private loadClarity() {
        const script = document.createElement("script");
        // Définissez les attributs du script
        script.type = "text/javascript";
        script.async = true;
        script.src = "https://www.clarity.ms/tag/qpxdsyu247";

        // Ajoutez le script au DOM
        const firstScript = document.getElementsByTagName("script")[0];
        firstScript?.parentNode?.insertBefore(script, firstScript);

        // Initialisez la fonctionnalité Clarity
        (window as any).clarity =
            (window as any).clarity ||
            function () {
                ((window as any).clarity.q = (window as any).clarity.q || []).push(arguments);
            };
    }
}

const analyticsUtils = new AnalyticsUtils();
export { analyticsUtils };
